import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, notification, Radio} from "antd"
import {markError} from "../../../../services/api/3dApi"

class MarkItemError extends Component {
    state = {
        loading: false,
        error: '',
        error_type: 'print',
    }

    _onMarkItemError = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {inputValue, id} = this.props
            const {error_type} = this.state

            const payload = {
                error_type: error_type === "wrong_color_design" ? "print" : error_type,
                error_procedure: 'qc_completed'
            }

            if(error_type === "wrong_color_design") payload.error_detail = "Khác màu design"

            const {data: response} = await markError(id, payload)

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                }, () => {
                    const {onClose} = this.props

                    if (typeof onClose === 'function') {
                        onClose()
                    }

                    notification.error({
                        message: 'Đánh dấu lỗi không thành công',
                        description: `Bạn đã đánh dấu lỗi cho item ${inputValue} không thành công`,
                    })
                })
            }

            this.setState({
                loading: false,
                error: ''
            }, () => {
                const {onClose, reset} = this.props

                if (typeof onClose === 'function' && typeof reset === 'function') {
                    onClose()
                    reset()
                }

                notification.success({
                    message: 'Đánh dấu lỗi thành công',
                    description: `Bạn đã đánh dấu lỗi cho item ${inputValue} thành công`,
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            }, () => {
                notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: e.message,
                })
            })
        }
    }

    _handleChangeRadio = (e) => {
        const {value, name} = e.target

        this.setState({
            [name]: value
        })
    }

    _onCloeModal = () => {
        this.setState({
            loading: false,
            error: '',
            error_style: 'detail',
            error_type: 'print',
            error_detail: ''
        }, () => {
            const {onClose} = this.props

            if (typeof onClose === 'function') {
                onClose()
            }
        })
    }

    render() {
        const {isOpen, isPartnerGlobal} = this.props
        const {loading, error_type} = this.state

        return (
            <div className="MarkItemError">
                <Modal
                    visible={isOpen}
                    title="Đánh dấu item QC lỗi"
                    onOk={this._onMarkItemError}
                    onCancel={this._onCloeModal}
                    className='MarkItemErrorModal MarkItemModalQCComplete'
                    footer={[
                        <Button key="back" onClick={this._onCloeModal}>
                            Hủy
                        </Button>,
                        <Button key="submit" type="danger" loading={loading} onClick={this._onMarkItemError}>
                            Đánh dấu lỗi
                        </Button>
                    ]}
                >
                    <div className="Content">
                        <div className="ErrorStyle">
                            <label htmlFor="error_type" className="LabelError">Loại lỗi</label>
                            {
                                isPartnerGlobal ? 
                                <Radio.Group id="error_type" name='error_type' onChange={this._handleChangeRadio}
                                    value={error_type}>
                                    <Radio value='print'>Lỗi in</Radio>
                                    <Radio value='cut'>Lỗi cắt</Radio>
                                    <Radio value='billet'>Lỗi phôi</Radio>
                                </Radio.Group> : 
                                <Radio.Group id="error_type" name='error_type' onChange={this._handleChangeRadio}
                                            value={error_type}>
                                    <Radio value='print'>Lỗi in</Radio>
                                    <Radio value='press'>Lỗi ép</Radio>
                                    <Radio value='fabric'>Lỗi vải</Radio>
                                    <Radio value='sewing'>Lỗi may</Radio>
                                    <Radio value='wrong_color_design'>Khác màu design</Radio>
                                </Radio.Group>
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

MarkItemError.propTypes = {
    isOpen: PropTypes.bool,
    inputValue: PropTypes.string,
    id: PropTypes.string,
    onClose: PropTypes.func.isRequired
}

export default MarkItemError
